import { AfterViewInit, Component, HostListener, Injectable, OnInit } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

import { CredentialService } from "./credential.service";
import { UserService } from "./services/user.service";

@Injectable()
@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, AfterViewInit {
  title: string;
  loading: boolean;

  constructor(
    private _credentialService: CredentialService,
    private userService: UserService,
    private readonly router: Router,
    private translateService: TranslateService
  ) {
    this.translateService.setDefaultLang("english");
    this.loading = false;
    this.title = this.translateService.instant("app.app");
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.loading = false;
      }
    });
  }

  @HostListener("window:storage")
  async onStorageChange() {
    if (this._credentialService.isUserOrTokenInconsistent()) {
      // another tab may have stored a selector token, which belongs on the selector, not the dashboard
      window.open(this._credentialService.getPostLoginUrl(), "_self");
    }
  }
}
